import React, {FunctionComponent, useState, useEffect, Fragment} from "react"
import {TimeLineDto} from "@murphy-frontend/common/interfaces/IDroneEventsApi"
import {IconContext} from "react-icons/lib"
import {FaRegCircleCheck} from "react-icons/fa6"
import {FaDotCircle} from "react-icons/fa"
import {FaRegCircle} from "react-icons/fa6"
import {convertEventStatus} from "@murphy-frontend/common/utils"
import {useUser} from "../../../common/contexts/UserContext"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"
import {getConvertedDateDayjs} from "@murphy-frontend/common/services/TimeService"

interface EventMapProps {
	steps?: TimeLineDto[]
}

const EventMap: FunctionComponent<EventMapProps> = ({steps}) => {
	const [step, setStep] = useState<TimeLineDto>()
	const [activeStep, setActiveStep] = useState(steps.length - 1)
	const {timeZone} = useUserPreferences()

	const {user} = useUser()

	useEffect(() => {
		setStep(steps[steps.length - 1])
		const idx = steps.findIndex(stp => !stp.Username)
		if (idx === -1) setActiveStep(steps.length - 1)
		else if (idx === 0) setActiveStep(0)
		else setActiveStep(idx - 1)
	}, [steps])

	const popClasses = (name: string, active: boolean) => {
		if (active) return name
		else return `${name} ${name}--inactive`
	}

	const isUserYou = (username: string) => {
		if (username === user.Email) return "You"
		else return username
	}

	if (!step) return <></>

	return (
		<div className='event-flow-map-container'>
			<div className='event-flow-map-icons' style={{height: steps.length * 100 + "px"}}>
				{steps.map((step, idx) => (
					<Fragment key={idx}>
						{idx !== steps.length - 1 && (
							<div
								className={popClasses("event-flow-hor-line", idx < activeStep)}
								style={{top: (idx / steps.length) * 100 + "%", height: (1 / steps.length) * 100 + "%"}}
							></div>
						)}
						{idx > activeStep ? (
							<IconContext.Provider value={{className: "btn-icon--inactive"}}>
								<FaRegCircle />
							</IconContext.Provider>
						) : (
							<IconContext.Provider value={{className: popClasses("btn-icon", !!step?.Username)}}>
								{convertEventStatus(step.status) ? (
									idx === activeStep ? (
										<FaDotCircle />
									) : (
										<FaRegCircleCheck />
									)
								) : (
									<FaRegCircle />
								)}
							</IconContext.Provider>
						)}
					</Fragment>
				))}
			</div>
			<div className='event-flow-map-text'>
				{steps.map(step => (
					<div className={popClasses("event-flow-map-text-container", !!step.Username)} key={step.key}>
						<div className='event-flow-map-title'>{step.label}</div>
						<div className='event-flow-map-subtext'>
							{step?.Username
								? `by ${isUserYou(step.Username)} at ${getConvertedDateDayjs(step.time, timeZone).format("HH:mm, DD MMM YYYY")}`
								: ""}
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default EventMap
